<div class="page-wrapper">
    <div class="buttons-container">
        <div
            class="button-wrapper row-buttons"
            role="button"
            tabindex="0"
            (click)="printSensorCableTable()"
            (keydown.enter)="printSensorCableTable()">
            {{ 'channel.print' | translate }}
        </div>

        <input type="file" class="excelFile" (change)="excelFileSelected($event)" #excelInput />
        <div
            class="import button-wrapper"
            data-cy="channels-import-button"
            role="button"
            [attr.tabindex]="isImportButtonDisabled ? -1 : 0"
            [attr.aria-disabled]="isImportButtonDisabled"
            (click)="importSensorCableTable()"
            (keydown.enter)="importSensorCableTable()"
            [class.disabled]="isImportButtonDisabled">
            <mat-icon svgIcon="import"></mat-icon>
            <span>{{ 'channel.import' | translate }}</span>
        </div>
        <div
            class="export button-wrapper"
            data-cy="channels-download-button"
            role="button"
            [attr.tabindex]="isExportButtonDisabled ? -1 : 0"
            [attr.aria-disabled]="isExportButtonDisabled"
            (click)="exportSensorCableTable()"
            (keydown.enter)="exportSensorCableTable()"
            [class.disabled]="isExportButtonDisabled">
            <mat-icon svgIcon="export"></mat-icon>
            <span>{{ 'channel.export' | translate }}</span>
        </div>
    </div>

    <div class="search-container" [class.disabled]="!userCanEdit">
        <div class="filter-container">
            <ng-container
                *ngTemplateOutlet="
                    selectorField;
                    context: {
                        name: fcuSelector,
                        label: 'sensor-cable-tag.filter.fcu',
                        dataCy: 'sensor-cable-fcu-no-dropdown-field',
                    }
                "></ng-container>

            <ng-container
                *ngTemplateOutlet="
                    selectorField;
                    context: {
                        name: fuSelector,
                        label: 'sensor-cable-tag.filter.fu',
                        dataCy: 'sensor-cable-fu-no-dropdown-field',
                    }
                "></ng-container>

            <ng-container
                *ngTemplateOutlet="
                    selectorField;
                    context: {
                        name: slotSelector,
                        label: 'sensor-cable-tag.filter.slot',
                        dataCy: 'sensor-cable-slot-no-dropdown-field',
                    }
                "></ng-container>

            <div>{{ 'sensor-cable-tag.filter.type' | translate }}</div>
            <div class="selector slot-type-input" data-cy="sensor-cable-type-field" [class.disabled]="!selectedSlotNum">
                <div>
                    {{ slotType ? slotType : ('sensor-cable-tag.filter.select' | translate) }}
                </div>
            </div>

            <ng-container *ngIf="isDOSlot()">
                <ng-container
                    *ngTemplateOutlet="
                        selectorField;
                        context: {
                            name: outputSelector,
                            label: 'sensor-cable-tag.filter.output',
                            dataCy: null,
                        }
                    "></ng-container>
            </ng-container>

            <ng-container *ngIf="selectedFcuNum">
                <div
                    class="clear-selectors"
                    role="button"
                    tabindex="0"
                    (click)="clearSelectors()"
                    (keydown.enter)="clearSelectors()">
                    <mat-icon svgIcon="close" class="icon" />
                    <div>
                        {{ 'sensor-cable-tag.selected.clear' | translate }}
                    </div>
                </div>
            </ng-container>
        </div>
        <app-channel-text-input
            class="search-input"
            [value]="searchChannelInput"
            [label]="'sensor-cable-tag.filter.channel.legend'"
            [maxLength]="40"
            icon="search"
            [isDisabled]="!selectedSlot || emptySlotSelected()"
            (onInputChange)="searchChannel($event.value)"></app-channel-text-input>
    </div>

    <ng-container *ngIf="shouldShowSelectMessage()">
        <div class="text">
            {{ 'sensor-cable-tag.not-selected-inputs' | translate }}
        </div>
    </ng-container>
    <ng-container *ngIf="shouldShowNotFound()">
        <div class="text">{{ 'sensor-cable-tag.not-found' | translate }}</div>
    </ng-container>
    <ng-container *ngIf="emptySlotSelected()">
        <div class="text">{{ 'sensor-cable-tag.empty-slot' | translate }}</div>
    </ng-container>
    <ng-container *ngIf="isDOSlot() && !selectedOutput">
        <div class="text">
            {{ 'sensor-cable-tag.output-type-not-selected' | translate }}
        </div>
    </ng-container>
    <ng-container *ngIf="shouldShowChannels()">
        <app-sensor-cable-tag-channels
            style="flex: 1; height: 100%; display: contents"
            #slotChannels
            [userCanEdit]="userCanEdit"
            [selectedSlot]="selectedSlot"
            [selectedOutput]="selectedOutput"
            [channelInput]="channelInput"
            [vesselId]="vessel.id"
            (channelsUpdated)="onChannelsUpdated($event)"></app-sensor-cable-tag-channels>
    </ng-container>
</div>

<!-- One reusable dropdown field (label + trigger + options) used for FCU, FU, Slot and Output -->
<ng-template #selectorField let-name="name" let-label="label" let-dataCy="dataCy">
    <div>{{ label | translate }}</div>
    <div
        class="selector"
        role="button"
        [attr.data-cy]="dataCy"
        [attr.tabindex]="isSelectorDisabled(name) ? -1 : 0"
        [attr.aria-expanded]="openSelector === name"
        [class.selected]="openSelector === name"
        [class.disabled]="isSelectorDisabled(name)"
        (click)="toggleSelector(name, $event)"
        (keydown.enter)="toggleSelector(name, $event)">
        <div>{{ getSelectorText(name) }}</div>
        <mat-icon class="arrow" svgIcon="dropdown-arrow" />
        <ng-container *ngIf="openSelector === name">
            <ng-container *ngTemplateOutlet="selector; context: { selector: name }"></ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #selector let-selector="selector">
    <div class="options-wrapper" #selectorElement>
        <div
            *ngFor="let option of getSelectorOptions(selector); trackBy: trackByOption"
            class="selector-option"
            data-cy="sensor-cable-dropdown-option"
            (click)="optionSelected(selector, option); $event.stopPropagation()">
            {{ getOptionLabel(selector, option) }}
        </div>
    </div>
</ng-template>

<ng-container *ngIf="isLoading">
    <div class="loading-container">
        <app-loading-spinner [custom]="true" class="spinner-component" size="80" strokeWidth="3"></app-loading-spinner>
    </div>
</ng-container>

<app-confirmation-window
    #slotChangeConfirmation
    [mainLabel]="'sensor-cable-tag.unsaved-changes.title'"
    [subLabel]="'sensor-cable-tag.unsaved-changes.subtitle'"
    [discardLabel]="'channel.page.exit-confirmation.discard'"
    [goBackLabel]="'channel.page.exit-confirmation.go-back'"
    [saveLabel]="'channel.page.exit-confirmation.save'"
    [saveIsDisabled]="!tableHasChanges() || tableHasErrors()">
</app-confirmation-window>

<app-confirmation-window
    #importErrorDialog
    [mainLabel]="'excel-channel-import.errors.title'"
    [subLabel]="importErrorMessage"
    [saveLabel]="'dlg.notification.close-button'"
    [errorIcon]="true">
</app-confirmation-window>